import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const SITUATIONS = [
    "Uczeń odpowiada tylko: nie wiem.",
    "Jedna osoba mówi, a reszta grupy milczy.",
    "Rozmowa zamienia się w przesłuchanie.",
    "Uczeń chce tylko rozmawiać, ale brakuje mu języka.",
    "Grupa jest zmęczona po pracy.",
    "Uczniowie są na zupełnie różnych poziomach.",
    "Temat kończy się po kilku minutach.",
    "Uczeń robi ćwiczenia, ale nie wykorzystuje języka w rozmowie.",
];

export const Problems = () => (
    <section data-testid="problem-section" className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                kicker="Brzmi znajomo?"
                title="To są sytuacje, których nie da się przewidzieć w konspekcie"
            />

            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {SITUATIONS.map((s, i) => (
                    <Reveal key={s} delay={(i % 4) * 0.08}>
                        <figure
                            data-testid={`problem-speech-bubble-${i + 1}`}
                            className={`relative h-full rounded-3xl bg-white border border-border px-6 pt-8 pb-6 shadow-soft transition-all duration-300 hover:shadow-card hover:-translate-y-1 ${
                                i % 2 === 0 ? "sm:rotate-[-0.6deg]" : "sm:rotate-[0.6deg]"
                            }`}
                        >
                            <Quote className="absolute top-4 right-5 w-6 h-6 text-hl-pink" />
                            <blockquote className="font-display text-[1.05rem] font-semibold text-ink leading-snug">
                                „{s}”
                            </blockquote>
                            <span className="absolute -bottom-2 left-8 w-4 h-4 bg-white border-b border-l border-border rotate-[-45deg]" />
                        </figure>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.15}>
                <p
                    data-testid="problem-summary"
                    className="mt-16 max-w-3xl mx-auto text-center font-display text-xl sm:text-2xl font-semibold text-ink text-balance leading-snug"
                >
                    Nie potrzebujesz kolejnej listy ogólnych porad. Potrzebujesz{" "}
                    <span className="bg-tang px-2 py-0.5 rounded-lg box-decoration-clone">
                        odpowiedzi dopasowanej do konkretnej sytuacji
                    </span>
                    , która właśnie wydarza się na Twojej lekcji.
                </p>
            </Reveal>
        </div>
    </section>
);
